import { useState, useEffect } from 'react';

const ResponsiveImage = ({ 
  src, 
  alt, 
  width, 
  height, 
  className = "", 
  style = {},
  loading = "lazy",
  sizes = "100vw",
  ...props 
}) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Generate responsive image sources if needed
  const generateSrcSet = (baseSrc) => {
    if (!baseSrc || baseSrc.includes('http')) return baseSrc;
    
    const extension = baseSrc.split('.').pop();
    const baseName = baseSrc.replace(`.${extension}`, '');
    
    // For now, just return the original src
    // In a real implementation, you'd have multiple sizes
    return baseSrc;
  };

  useEffect(() => {
    setImageSrc(src);
    setIsLoaded(false);
    setHasError(false);
  }, [src]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = () => {
    setHasError(true);
    // Fallback to a placeholder or default image
    console.warn(`Failed to load image: ${src}`);
  };

  const imageStyle = {
    ...style,
    aspectRatio: width && height ? `${width}/${height}` : 'auto',
    objectFit: 'contain',
    maxWidth: '100%',
    height: 'auto',
    transition: 'opacity 0.3s ease',
    opacity: isLoaded ? 1 : 0.7
  };

  if (hasError) {
    return (
      <div 
        className={`image-placeholder ${className}`}
        style={{
          ...imageStyle,
          backgroundColor: '#f3f4f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6b7280',
          fontSize: '0.875rem'
        }}
      >
        {alt || 'Image not available'}
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      srcSet={generateSrcSet(imageSrc)}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      className={className}
      style={imageStyle}
      onLoad={handleLoad}
      onError={handleError}
      {...props}
    />
  );
};

export default ResponsiveImage;